// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MultiselectController from "./multiselect_controller"
application.register("multiselect", MultiselectController)

import FilterPanelController from "./filter_panel_controller"
application.register("filter-panel", FilterPanelController)

import EpisodePickerController from "./episode_picker_controller"
application.register("episode-picker", EpisodePickerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import AuthCodeFormController from "./auth_code_form_controller"
application.register("auth-code-form", AuthCodeFormController)

import OrderFormController from "./order_form_controller"
application.register("order-form", OrderFormController)

import InputmaskController from "./inputmask_controller"
application.register("inputmask", InputmaskController)

import ActiveTabController from "./active_tab_controller"
application.register("active-tab", ActiveTabController)

import AccordionToggleController from "./accordion_toggle_controller"
application.register("accordion-toggle", AccordionToggleController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import BatchSelectController from "./batch_select_controller"
application.register("batch-select", BatchSelectController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import LoadMoreController from "./load_more_controller"
application.register("load-more", LoadMoreController)

import FlashToastController from "./flash_toast_controller"
application.register("flash-toast", FlashToastController)

import LocaleTabsController from "./locale_tabs_controller"
application.register("locale-tabs", LocaleTabsController)
